export const topBarHeight = 64;
export const sideNavWidth = 250;
export const navbarHeight = 60;
export const sidenavCompactWidth = 100;
export const containedLayoutWidth = 1200;

// ------------------------------------------------------------------------

// demo
export const COMPANY_ID = "47e50031-8e4a-4b32-969f-208732f5c4b1";
export const area1_company_division_id = "041b3954-7842-49d8-8054-e1500d81b786";

// testing
export const admin_company_id = "7cb4a1ec-0670-45a1-a367-43ab143fb4c4"; //ADMIN --- Evento
// export const COMPANY_ID = "ff620da6-1bd9-4be0-a33d-cb8ebe2aa390" //ADMIN --- Area 1

// Roles
export const ADMIN = "7cd3a9d6-f40b-4604-b399-5245a6a63c87";
export const CONVENER = "fc734048-8aae-4581-9ba2-2e96b6137f75";
export const MEMBER = "52ac0123-46a3-40d9-ac1c-4d051b331999";
export const HOTEL_USER = "80efa789-8d3f-462a-87a3-433d1f757feb";

// Data Limits
export const otpLength = 6;
export const cardLimit = 12;
export const checkInCheckOutLimit = 2;
export const transactionsValueLimit = 2;

// Status
export const pendingState = 2;
export const shipmentStatus = {
  order_placed: { label: "Order Placed", color: "warning" },
  in_transit: { label: "In Transit", color: "info" },
  shipped: { label: "Shipped", color: "primary" },
  delivered: { label: "Delivered", color: "success" },
};
export const approvalStatus = ["View All", "Approved", "Rejected", "Pending"];

// Events ------------------------------------------------------------------
// Types
export const NATIONAL_EVENT = "National Event";
export const AREA_EVENT = "Area Event";
export const INTER_AREA_EVENT = "Inter Area Event";

export const EVENT_VISIBILITY_OPTIONS = [
  { label: "All Events", value: "" },
  { label: "National Event", value: "national_event" },
  { label: "Inter Area Event", value: "inter_area_event" },
  { label: "Area Event", value: "area_event" },
];

export const EVENT_DISPLAY_ORDER = [
  "national_event",
  "inter_area_event",
  "area_event",
];
// Category
export const ticketingEvent = "ticketing";
export const TICKETING_LABEL = "Round Table Event";
export const FUNDRAISING_LABEL = "Fundraiser";
export const PAID_GUEST_LABEL = "Round Table Guest";

// Scope
export const EVENT_SCOPE_OPTIONS = [
  { label: "Both (Round Table Members and Non-Members)", value: 0 },
  { label: "Round Table Members Only", value: 1 },
];

// Products ----------------------------------------------------------------
export const TICKET_CATEGORY_ID = "ac980e73-a7fa-46c9-93c2-1321230c712f";
export const stag_entry_ticket = "Stag Entry";

//Hotels ------------------------------------------------------------------
export const HOTEL_CATEGORY_ID = "e452a27e-23b2-4755-b35e-a1f3b46c778f";

// Payment
export const PLATFORM_FEE = 0.02; // 2%
export const ROUTE_FEE = 0.0025; // 0.25%
export const GST = 0.18; // 18%

// Basis Point Constants
export const PLATFORM_FEE_BPS = 200; // 2%
export const ROUTE_FEE_BPS = 25; // 0.25%
export const GST_BPS = 1800; // 18%
export const HALF_GST_BPS = 900; // 9%
// special effective rate for split + org pays flow
export const SPLIT_ORG_ROUTE_FEE_BPS = 24.9283;

export const platformFeeWithGSTRate = PLATFORM_FEE * (1 + GST); // 2% + 18% GST on that 2%
export const routeFeeWithGSTRate = ROUTE_FEE * (1 + GST); // 0.25% + 18% GST on that 0.25%

export const razor_pay = "5a3a9217-ed1c-4bd2-ba0a-c55ea91ccdd7";
export const PAYMENT_SUCCESS_REDIRECT_KEY = "paymentSuccessRedirect";

export const paymentMethods = {
  1: "UPI Payment",
  2: "Bank Payment",
  3: "Cash Payment",
  4: "RazorPay Payment",
};

export const WITH_CHARGES = "with_razorpay_charges"; // user pay
export const DEDUCT_CHARGES = "deduct_razorpay_charge"; // organization pay

// Vendor POS Payment
export const VENDOR_POS_PAYMENT = "vendor_pos_payment";
export const VENDOR_POS_LABEL = "Vendor POS";

// Cookie -------------------------------------------------------------------
// Cookie utility constants
export const COOKIE_EXPIRY_DAYS = 90;
export const PREFERENCE_COOKIE_EXPIRY_DAYS = 90;
export const USER_PREFERRED_AREA_COOKIE = "user_preferred_area";
export const USER_PREFERRED_LOCATION_COOKIE = "user_preferred_location";

// Cookie function default values
export const DEFAULT_COOKIE_EXPIRY_DAYS = COOKIE_EXPIRY_DAYS;
export const COOKIE_PATH = "/";
export const COOKIE_EXPIRY_DATE = "";

// API Status Codes ----------------------------------------------------------
export const SUCCESS_STATUS_CODES = [200, 201];
export const UNAUTHORIZED_STATUS_CODE = 401;

// Validations ---------------------------------------------------------------
// Patterns
export const NAME_PATTERN = /^[a-zA-Z\s().]*$/;
export const PHONE_PATTERN = /^(?:\+\d{1,3}\s?)?\d{10}$/;

// Error Messages ------------------------------------------------------------
export const ERROR_MESSAGES = {
  AREA_REQUIRED: "Area is required.",
  LOCATION_REQUIRED: "Table is required.",
  MEMBER_NAME_REQUIRED: "Member Name is required.",
  NAME_REQUIRED: "Name is required.",
  INVALID_NAME: "Only letters, spaces, and periods are allowed!",
  MOBILE_NUMBER_REQUIRED: "Mobile Number is required.",
  INVALID_PHONE: "Enter a valid phone number.",
  AREAS_NOT_AVAILABLE: "Areas are not available! Try again!",
  LOCATIONS_NOT_AVAILABLE: "Locations are not available! Try again!",
  LOCATIONS_BY_AREA_NOT_AVAILABLE:
    "Locations for this area are not available! Try again!",
  MEMBER_LIST_NOT_AVAILABLE: "Member list is not available! Try again!",
  SELECT_MEMBER_FIRST: "Please select a member first.",
  USER_NOT_FOUND: "User not found",
  FAILED_TO_REGISTER: "Failed to register! Try again!",
};

export const BULK_REGISTRATION_STEPS = [
  "Upload",
  "Validation and confirmation",
  "Completion summary",
];

export const TEMPLATE_DOWNLOAD_URL =
  "/templates/user-registration-template.xlsx";

// Bulk registration status
export const BULK_REGISTRATION_STATUS = {
  PENDING: "pending",
  UPLOADING: "uploading",
  VALIDATING: "validating",
  SUCCESS: "success",
  ERROR: "error",
};

// Files

export const ACCEPTED_FILE_TYPES = [".xlsx", ".xls", ".csv"];
export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
export const BANNER_IMAGE_LIMIT = 5;
export const LOGO_IMAGE_LIMIT = 1;
